import React from 'react'

import { Flex, Image } from '@chakra-ui/react'
const Header = () => {
  return (
    <Flex width="100%" height="80px" padding="10px" paddingLeft="30px">
      <Image
        src="https://alienworlds-media-bucket.s3.eu-central-1.amazonaws.com/alienworlds_logo_81750a6c20.webp"
        width="150px"
        height="60px"
        alt=""
      />
    </Flex>
  )
}

export { Header }
